import { DataGridPro, GridColDef, GridSortModel } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from "react";
import { formatUtcToLocal } from "../../helper/utils";
import { UsersModel } from '../../models/UsersModel';
import { Box, Button, IconButton, LinearProgress, Tooltip } from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { Add } from '@mui/icons-material';
import { AddEditUsers } from '../AddEdit/AddEditUsers';
import useAuth from "../../context/AuthProvider";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from '../../helper/api';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
interface Iprops {
    UsersCL: UsersModel[],
    fetchData: () => void
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}



export const UsersList: React.FC<Iprops> = ({ UsersCL, fetchData, sortModel, setSortModel }) => {
    const [rows, setRows] = React.useState(UsersCL);
    const initialUserData: UsersModel = {
        userId: 0,
        userName: "",
        password: "",
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(),
        datemodified: new Date(),
        userEmail: "",
        firstName: "",
        lastName: "",
        modifiedBy: 0,
        createdBy: 0,
        roleIds: "",
        partnersId: 0,
        userRoles: '',
        customerName: '',
        // profilePicture: '',

    }


    const [Open, setOpen] = React.useState(false);
    const [loadingPartner, setloadingPartner] = React.useState(true);
    const [Formdata, setFormData] = React.useState(initialUserData);
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const { user } = useAuth();
    const token = user?.token;
    const [users, setUsers] = React.useState([])
    const [loading, setloading] = React.useState(false);

    const getpartnerfetch = () => {
        setloading(true);

        apiClient('/Users/getLoggedInUserPartnerId',
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                {
                    initialUserData.partnersId = user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer") ?
                        0
                        : Number(res.data)
                }
                setFormData(initialUserData);
                setOpen(true);
                setloadingPartner(false);
                console.log("in fetchuser", initialUserData);
            }).finally(() => {
                setloading(false);
            });


    }

    useEffect(() => {
        // getpartnerfetch();
    }, [])
    const [selectedOptions, setSelectedOption] = React.useState<string[] | string>([]);

    const columns: GridColDef[] = [

        {
            field: 'firstName', type: 'string', headerName: 'First Name', hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'firstName'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, flex: 0.8, headerAlign: 'left', align: 'left'
        },
        {
            field: 'lastName', type: 'string', headerName: 'Last Name', flex: 0.8, hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'lastName'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, headerAlign: 'left', align: 'left'
        },
        {
            field: 'userName', headerName: 'Username', width: 130, flex: 0.8, hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'userName'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, headerAlign: 'left', align: 'left'
        },
        {
            field: 'userEmail', type: 'string', headerName: 'Email ', flex: 1, hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'userEmail'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, headerAlign: 'left', align: 'left'
        },
        {
            field: 'dateCreated', type: 'date', headerName: 'Created Date ', hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'dateCreated'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', align: 'left', flex: 0.8, renderCell: (params) => (<div> {params.row.dateCreated ? formatUtcToLocal(params.row.dateCreated, "YYYY-MM-DD") : ""}</div>)
        },
        {
            field: 'userRoles', type: 'string', headerName: 'User Type', flex: 1, hideSortIcons: true, minWidth: 120,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'userRoles'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, headerAlign: 'left', align: 'left'
        },
        {
            field: 'customerName', type: 'string', headerName: 'Customer/Partner', flex: 1, hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                console.log("sortModel", sortModel);
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'customerName'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
              )}, headerAlign: 'left', align: 'left'
        },

        {
            field: 'isActive', type: 'text', headerName: 'Active user', flex: 0.6, hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                  (item: any) => item.field === 'isActive'
                );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )}, headerAlign: 'left', align: 'left', renderCell: (params) => (
                params.row.isActive === true ? "Active" : "InActive")
        },
        {
            field: 'userId', flex: 1, headerAlign: 'center', align: 'center', headerName: "Action", sortable: false, hideSortIcons: true, minWidth: 100,
            filterable: false,
            disableColumnMenu: true,
            disableExport: true,
            renderCell: (params) => (<div>

                <IconButton
                    color="primary"
                    onClick={() => { handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <EditOutlinedIcon fontSize="medium" color="primary" />
                    </Tooltip>

                </IconButton >
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.userId) }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        {params.row.isDeleted ? <RestoreFromTrashIcon /> : 
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                        }
                    </IconButton >
                    : ""}
            </div>)
        },
    ];

    const handleClickOpen = () => {
        {
            (user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) ?
                setSelectedOption([])
                : setSelectedOption(["6"])
        }
        getpartnerfetch();
    };
    const [SelectedRoles, setSelectedRoles] = React.useState<string[] | string>([]);
    const handleClose = () => {
        setFormData(initialUserData);
        setSelectedOption([]);
        setImageProfile('');


        fetchData();
        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);

    };
    const [imageProfile, setImageProfile] = useState<string>("");
    const handleEdit = (ILobData: UsersModel) => {

        
        const commaSeparatedIds: string[] = ILobData.roleIds?.split(',') || [];
      
        const RoleIds: number[] = commaSeparatedIds.map(id => Number(id));


        let CheckData: UsersModel = {
            userEmail: ILobData.userEmail,
            firstName: ILobData.firstName,
            lastName: ILobData.lastName,
            roleIds: RoleIds.toString(),
            userId: ILobData.userId,
            dateCreated: new Date(),
            partnersId: 0,
            // profilePicture: ILobData.profilePicture,
        }

        // setFormData(CheckData);
        let abc = ILobData.roleIds?.split(',') ?? [];
        let f = abc.map(e => e.trim());
    
        setSelectedRoles(f);
        setSelectedOption(f);
        ILobData.password = "";
        setFormData(ILobData);
        // setImageProfile(ILobData.profilePicture ?? "");
        setOpen(true);
     
    };


    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/Users/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            fetchData();
                            setOpen(false);
                        })
                    Swal.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    )
                }
            })
        //call api to save data
        // fetch(config.url.API_URL + "/Users/Delete?id=" + `${id}`,
        //     {
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //         }),
        //         method: "Delete",
        //     }
        // )
        //     .then((response) => {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //         throw new Error('Something went wrong');
        //     })
        //     .then((res) => {
        //         alert("Data Successfully Deleted")
        //         fetchData();
        //         setOpen(false);
        //     }).catch((error) => {
        //         console.log(error)
        //     });


    };


    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {loading && <LinearProgress sx={{ position: 'fixed', top: 0, width: '100%', left: 0, backgroundColor: '#132D3D', zIndex: 9999 }} />}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, lg: 2 },
                    py: 1.5,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 70,
                    mb: 3,
                    marginLeft: { xs: '-24px', lg: '0px' },
                    marginRight: { xs: '-24px', lg: '0px' },
                }}
            >
                <span className="d-flex card-title" style={{ fontWeight: 600, fontSize: '0.9375rem', color: '#334155' }}>
                    Users
                </span>
                <Box sx={{ flex: 1, minWidth: 120 }} />
                <Button
                    variant="contained"
                    size="medium"
                    startIcon={<Add />}
                    onClick={handleClickOpen}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        backgroundColor: '#2099d2',
                        '&:hover': { backgroundColor: '#176990' },
                        px: 2,
                    }}
                >
                    Add User
                </Button>
            </Box>
            <Box
                sx={{
                    // height: '100%',
                    width: '100%',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    height: 'calc(100vh - 250px)',
                }}
            >
                <DataGridPro
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    getRowId={(r) => r.userId}
                    rows={UsersCL}
                    columns={columns}
                    style={{ textAlign: 'center' }}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        '& .MuiDataGridPro-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
                            pl: 1,
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-main': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: 0,
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                    }}
                />
            </Box>
            {<AddEditUsers
                handleClose={handleClose}
                Open={Open}
                UsersBL={Formdata}
                handleSubmit={handleSubmit}
                setSelectedOption={setSelectedOption}
                selectedOptions={selectedOptions}
                initValues={initialUserData}
                SelectedRoles={SelectedRoles}
                setSelectedRoles={setSelectedRoles}
                // imageProfile ={imageProfile}
                // setImageProfile={setImageProfile}

            ></AddEditUsers>}

        </div>)
}